import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/faq.css';
import { getFaqs } from '../services/faqService';

const FAQItem = ({ question, answer, isOpen, toggle }) => {
    return (
        <div className={`faq-item ${isOpen ? 'active' : ''}`}>
            <div className="faq-question" onClick={toggle}>
                {question}
            </div>
            <div
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: answer || "" }}
            >
            </div>
        </div>
    );
};

const FAQ = () => {

    const [error, setError] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);
    const [faqs, setFaqs] = useState([]);

    const [sectionName, setSectionName] = useState('');

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                setError(null);
                const response = await getFaqs();
                if (response) {
                    // Laravel Controller returns { data: [...], recordsTotal: ... }
                    // So needed data is inside response.data
                    if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                        setFaqs(response.data);
                        console.log("First Item Name:", response.data[0].name); // Debugging
                        
                        // Find FIRST item that has a valid name (skip empty ones)
                        const itemWithTitle = response.data.find(item => item.name && item.name.trim() !== "");
                        const dynamicTitle = itemWithTitle ? itemWithTitle.name : "FAQ Section";
                            
                        setSectionName(dynamicTitle);
                    } else if (Array.isArray(response) && response.length > 0) {
                         setFaqs(response);
                         const serverName = response[0].name;
                         const dynamicTitle = (serverName && serverName.trim() !== "") 
                            ? serverName 
                            : "FAQ Section";
                         setSectionName(dynamicTitle);
                    } else {
                        // Empty list case
                        setFaqs([]);
                        setSectionName("FAQ Section");
                    }
                }
            } catch (error) {
                console.error("Failed to load FAQ data", error);
                setError(error.message || "Something went wrong fetching data.");
            }
        };
        fetchData();
    }, []);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const renderSectionTitle = (title) => {
        if (!title) return null;
        const words = title.split(' ');
        if (words.length > 1) {
             const firstWord = words[0];
             const rest = words.slice(1).join(' ');
             return <><span className="font-normal">{firstWord}</span> {rest}</>;
        }
        return title;
    };

    return (
        <>
            {/* Page Header */}
            <section id="main-banner-page" className="position-relative page-header contact-header section-nav-smooth parallax" style={{ zIndex: 5 }}>
                <div className="overlay overlay-dark opacity-6"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="page-titles whitecolor text-center padding">
                                <h2 className="font-bold"> FAQ</h2>
                                <h3 className="font-light py-2">{sectionName || "FAQ"}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg title-wrap mt-n5">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 whitecolor">
                                <h3 className="float-left">{sectionName || "FAQ"}</h3>
                                <ul className="breadcrumb top10 bottom10 float-right">
                                    <li className="breadcrumb-item hover-light"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item hover-light">FAQ</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Page Header ends */}

            {/* FAQ Section */}
            <section id="faq-section" className="stay-connect-section bglight position-relative padding_top padding_bottom_half noshadow">
                <div className="container whitebox">
                    <div className="widget py-5">
                        <div className="row">
                            <div className="col-md-12 text-center wow fadeIn mt-n3" data-wow-delay="300ms">
                                <h2 className="heading bottom30 darkcolor font-light2 pt-1">
                                    {renderSectionTitle(sectionName || "FAQ Section")}
                                    <span className="divider-center"></span>
                                </h2>
                            </div>


                            <div className="col-lg-10 offset-lg-1">
                                {error && (
                                    <div className="alert alert-danger text-center">
                                        Error Loading Data: {error}
                                        <br />
                                        <small>Please check if the backend is running and CORS is enabled.</small>
                                    </div>
                                )}
                                
                                {/* DEBUG VIEW - REMOVE LATER */}
                                {/* 
                                <div className="alert alert-warning">
                                    <small>Debug Data: {JSON.stringify(faqs[0])}</small>
                                </div> 
                                */}
                                
                                <div className="faq-list">
                                    {faqs.length > 0 ? (
                                        faqs.map((faq, index) => (
                                            <FAQItem
                                                key={index}
                                                question={faq.question}
                                                answer={faq.answer}
                                                isOpen={openIndex === index}
                                                toggle={() => toggleFAQ(index)}
                                            />
                                        ))
                                    ) : (
                                        !error && <p className="text-center">No FAQs found.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FAQ;
